module.exports = __webpack_public_path__ + "img/transportation.abe96141.png";